import { render, staticRenderFns } from "./actionable-button.vue?vue&type=template&id=bf4a8b4c&scoped=true&"
import script from "./actionable-button.vue?vue&type=script&lang=js&"
export * from "./actionable-button.vue?vue&type=script&lang=js&"
import style0 from "./actionable-button.vue?vue&type=style&index=0&id=bf4a8b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4a8b4c",
  null
  
)

export default component.exports